/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.modals.fields.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.validate',
  'acme.common.service.templates'
])

.controller('SettingsModalsFieldsController', ['$scope', '$state', '$rootScope', '$uibModalInstance', 'ValidateService', 'TemplatesService', 'field', 'customFieldType', 'existingCustomFieldNames', function($scope, $state, $rootScope, $uibModalInstance, ValidateService, TemplatesService, field, customFieldType, existingCustomFieldNames) {

    $scope.settingsModalsFields = {
      
      editMode: false,
      isSubmitted: false,
      
      title: '',
      label: '',
      values: '',
      errors: '',
      
      model: {},

      templates: {
        events: {
          ndx: '',
          label: '',
          format: '',
          values: []
        },
        donations: {
          dbFieldName: '',
          label: '',
          name: '',
          format: '',
          values: [],
          saleChannelsSupported: TemplatesService.orderSalesChannels(angular.copy(TemplatesService.salesChannels))
        },
        forms: {
          dbFieldName: '',
          label: '',
          name: '',
          format: 'Text',
          values: [],
          saleChannelsSupported: TemplatesService.orderSalesChannels(angular.copy(TemplatesService.salesChannels))
        }
      },

      customFieldType: customFieldType || 'events',

      field: field,
      format: [
        {
          name: 'Dropdown'
        },
        {
          name: 'Text'
        }
      ],
      
      init: function () {
        if(this.isEditModal()) {
          this.setFieldValues(this.field);
        } else {
          this.model = this.templates[this.customFieldType];
          this.title = 'Add field';
        }
      },
      
      isEditModal: function () {
        return !!this.field;
      },

      isType: function(type) {
        return customFieldType === type;
      },

      setFieldValues: function (field) {
        var self = $scope.settingsModalsFields;
        self.title = this.field.label;
        self.model.id = this.field.id;
        if (this.isType('events')) {
          self.model.ndx = this.field.ndx;
        } else {
          self.model.dbFieldName = this.field.dbFieldName;
          self.model.name = this.field.name;
          self.model.saleChannelsSupported = this.field.saleChannelsSupported;
        }
        self.model.label = this.field.label;
        self.model.format = this.field.format;
        self.values = this.checkForFieldValues();
        self.editMode = true;
      },
      
      checkForFieldValues: function () {
        return ((this.field.values && this.field.values.length) ? this.field.values.join('\n') : '');
      },
      
      isValid: function (field) {
        var r = true;
        
        if(this.isSubmitted) {
          r = ValidateService.validate([
            { 
              len: { value: this.model[field] }
            }
          ]);
        }
        
        return r;
      },

      isValidName: function () {
        var r = true,
            re = new RegExp(/^(\w)+$/,'g');

        if(this.isSubmitted && !this.isType('events')) {
          r = ValidateService.validate([
              {
                len: { value: this.model.name }
              }
            ]) &&
            re.test(this.model.name);
        }

        return r;
      },

      save: function() {
        var data = this.model;

        this.isSubmitted = true;

        if(this.isValidName() && this.isValid('label') && this.isValid('format')) {

          this.splitValues();

          if (!this.isType('events')) {
            data = angular.extend(this.model, {
              saleChannelsSupported: this.getSalesChannels()
            });
          }
          $uibModalInstance.close(data);
        }
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },
      
      close: function (model) {
        $uibModalInstance.close(model);  
      },
      
      splitValues: function () {
        this.model.values = this.values.split('\n');
      },

      getSalesChannels: function () {
        var channels = [],
          i, ii;
        for (i=0, ii=this.model.saleChannelsSupported.length; i < ii; i++) {
          if (this.model.saleChannelsSupported[i].enabled) {
            channels.push(this.model.saleChannelsSupported[i].channel);
          }
        }
        return channels || [];
      }

    };

    $scope.settingsModalsFields.init();

}]);